<template>
  <b-overlay :show="loading || saving">
    <div class="behavioral-record-container p-4">
      <div class="card shadow-sm border-0">
        <div
          class="card-header bg-light-blue py-3 d-flex justify-content-between align-items-center border-bottom"
        >
          <div class="text-center flex-grow-1">
            <!-- Updated by Jarir 2026-03-30 : Added Bangladesh Gazette header -->
            <p
              class="mb-1 font-weight-bold"
              style="color: #333; font-size: 0.85rem"
            >
              Bangladesh Gazette - বাংলাদেশ গেজেট
            </p>
            <h5 class="mb-1 font-weight-bold text-primary">Form No: 07</h5>
            <p class="mb-1 text-muted small">
              Under Section 7, Rules (1) and (2)
            </p>
            <p class="mb-1 text-muted small">Fifth Part (E)</p>
            <h6 class="mb-0 font-weight-bold">Behavioral Record</h6>
            <p class="mb-0 small bn-text">আচরণ সংক্রান্ত তথ্যাদি</p>
          </div>
          <div class="d-flex align-items-center">
            <b-button
              variant="primary"
              @click="openAddModal"
              class="add-entry-btn shadow-sm"
              v-if="$acl && $acl['admin-service-book/behavioral-records'] == 2"
            >
              <i class="fa fa-plus mr-2"></i> Add
            </b-button>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-bordered mb-0 custom-table">
              <thead class="text-center bg-light-cyan">
                <tr>
                  <th
                    width="15%"
                    @click="sortBy('date')"
                    :class="
                      sortKey == 'date'
                        ? sortOrders['date'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Date<br />
                    <small class="bn-text">তারিখ</small>
                  </th>
                  <th
                    @click="sortBy('description')"
                    :class="
                      sortKey == 'description'
                        ? sortOrders['description'] > 0
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : 'sorting'
                    "
                    style="cursor: pointer"
                  >
                    Behavioral Description<br />
                    <small class="bn-text">আচরণের বিবরণ</small>
                  </th>
                  <th width="20%">
                    Signature of Owner/ Authorized Person<br />
                    <small class="bn-text"
                      >মালিক/প্রাধিকারপ্রান্ত ব্যক্তির স্বাক্ষর</small
                    >
                  </th>
                  <th width="20%">
                    Worker’s Signature/ Thumb Impression<br />
                    <small class="bn-text">শ্রমিকের স্বাক্ষর/টিপসই</small>
                  </th>
                  <th width="10%" v-if="$acl && $acl['admin-service-book/behavioral-records'] == 2">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="paginatedData.length == 0 && !loading">
                  <td :colspan="$acl && $acl['admin-service-book/behavioral-records'] == 2 ? 5 : 4" class="text-center py-5 text-muted">
                    No records found.
                    <!-- Updated: 2026-04-19 18:45:00 -->
                    <br><span class="bn-text">কোন তথ্য পাওয়া যায়নি</span>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in paginatedData"
                  :key="item.id"
                  class="text-center"
                >
                  <td>{{ formatDate(item.date) }}</td>
                  <td>
                    <div class="text-left">
                      <div class="font-weight-bold">
                        {{ getJsonValue(item.description, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.description, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <b-link v-if="item.owner_signature" @click="downloadWithName(item.owner_signature, 'Owner_Signature')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                    <!-- Updated by Jarir 2026-03-30 -->
                    <span v-else class="text-muted small"
                      >No Signatories found. Add a Signatory in HR Management Portal</span
                    >
                  </td>
                  <td>
                    <div class="d-flex flex-column align-items-center">
                      <b-link v-if="item.worker_signature" @click="downloadWithName(item.worker_signature, 'Worker_Signature')" class="mb-1">
                        <b-icon icon="download" scale="1.2"></b-icon> Signature
                      </b-link>
                      <b-link v-if="item.worker_thumb_impression" @click="downloadWithName(item.worker_thumb_impression, 'Thumb_Impression')">
                        <b-icon icon="download" scale="1.2"></b-icon> Thumb
                      </b-link>
                      <span v-if="!item.worker_signature && !item.worker_thumb_impression"
                        ></span
                      >
                    </div>
                  </td>
                  <td v-if="$acl && $acl['admin-service-book/behavioral-records'] == 2">
                    <b-dropdown
                      size="sm"
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template #button-content>
                        <i class="fa fa-ellipsis-v text-muted"></i>
                      </template>
                      <b-dropdown-item @click="editItem(item)"
                        ><i class="fa fa-edit mr-2 text-primary"></i>
                        Edit</b-dropdown-item
                      >
                      <b-dropdown-item @click="confirmDelete(item.id)"
                        ><i class="fa fa-trash mr-2 text-danger"></i>
                        Delete</b-dropdown-item
                      >
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="card-footer bg-white border-top py-3"
          v-if="pagination.pages > 1"
        >
          <b-pagination-nav
            v-model="pagination.currentPage"
            :number-of-pages="pagination.pages"
            base-url="#"
            prev-text="Previous"
            next-text="Next"
            first-number
            last-number
            align="center"
            class="mb-0"
          ></b-pagination-nav>
        </div>
      </div>

      <!-- Entry Modal -->
      <b-modal
        v-model="showModal"
        :title="isEdit ? 'Edit Behavioral Record' : 'Add New Behavioral Record'"
        @hidden="resetForm"
        size="lg"
        hide-footer
      >
        <form @submit.prevent="saveDetail" novalidate>
          <div class="row">
            <div class="col-12 border-bottom pb-3 mb-3">
              <b-form-group>
                <template #label>
                  Date (তারিখ)
                  <span class="text-danger">*</span>
                </template>
                <b-input-group>
                  <b-form-input
                    v-model="form.date"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    :state="dateState"
                  ></b-form-input>
                  <b-input-group-append>
                    <!-- Updated 2026-07-30 — max is the local today; toISOString() gave the UTC day, which is still yesterday before 06:00 local -->
                    <b-form-datepicker
                      v-model="form.date"
                      button-only
                      right
                      locale="en-US"
                      :max="formatDate(new Date())"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
                <!-- Updated by Jarir 2026-04-26 — real-time per-field error messages -->
                <!-- Updated 2026-07-30 — one element per field: see dateError -->
                <b-form-invalid-feedback :state="dateError ? false : null">{{ dateError }}</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 border-right">
              <h6 class="font-weight-bold border-bottom pb-2 mb-3">
                English Details
              </h6>
              <b-form-group>
                <template #label>
                  Behavioral Description: <span class="text-danger">*</span>
                </template>
                <!-- Updated 2026-07-30 — max length via vee-validate. Typing is not truncated: once past
                     the limit the field turns red with the message and saveDetail blocks the save. -->
                <b-form-textarea
                  v-model="form.description.en"
                  name="description_en"
                  v-validate="'max:500'"
                  data-vv-as="Behavioral Description"
                  rows="5"
                  :state="descriptionEnState"
                ></b-form-textarea>
                <!-- Updated by Jarir 2026-04-26 — real-time per-field error messages (empty + special-char-only) -->
                <!-- Updated 2026-07-30 — one element per field: see descriptionEnError -->
                <b-form-invalid-feedback :state="descriptionEnError ? false : null">{{ descriptionEnError }}</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <h6 class="font-weight-bold border-bottom pb-2 mb-3 bn-text">
                বাংলা তথ্য
              </h6>
              <b-form-group label="আচরণের বিবরণ:">
                <b-form-textarea
                  v-model="form.description.bn"
                  name="description_bn"
                  v-validate="'max:800'"
                  data-vv-as="আচরণের বিবরণ"
                  rows="5"
                  class="bn-text"
                  :state="descriptionBnState"
                ></b-form-textarea>
                <!-- Updated 2026-07-30 — this field is optional (saveDetail never requires it), so it
                     no longer reports "required" on submit. Only the rules that actually block the
                     save are reported, so a red field always means a blocked save. -->
                <b-form-invalid-feedback :state="descriptionBnError ? false : null">{{ descriptionBnError }}</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="row mt-3 border-top pt-3">
            <div class="col-md-4 text-center">
              <label class="font-weight-bold small d-block"
                >Owner's Signature:</label
              >
              <div v-if="ownerSigPreview" class="mt-2 text-center">
                <b-link @click="downloadWithName(owner_signature_raw, 'Owner_Signature')">
                  <b-icon icon="download" scale="1.2"></b-icon> Download
                </b-link>
              </div>
              <!-- Updated by Jarir 2026-03-30 -->
              <div v-else class="text-muted small">
                No Signatories found. Add a Signatory in HR Management Portal
              </div>
              <b-form-select
                v-model="selected_signatory_id"
                :options="signatoryOptions"
                class="mt-2"
                size="sm"
                @change="onSignatoryChange"
              ></b-form-select>
            </div>
            <div class="col-md-4 text-center border-left">
              <label class="font-weight-bold small d-block"
                >Worker's Signature
                <span class="bn-text">(শ্রমিকের স্বাক্ষর)</span>:</label
              >
              <div v-if="workerSigPreview" class="mt-2 text-center">
                <b-link @click="downloadWithName(worker_signature_raw, 'Worker_Signature')">
                  <b-icon icon="download" scale="1.2"></b-icon> Download
                </b-link>
              </div>
              <div v-else class="text-muted small">No signature available</div>
            </div>
            <div class="col-md-4 text-center border-left">
              <label class="font-weight-bold small d-block"
                >Thumb Impression <span class="bn-text">(টিপসই)</span>:</label
              >
              <div v-if="thumbImpPreview" class="mt-2 text-center">
                <b-link @click="downloadWithName(thumb_impression_raw, 'Thumb_Impression')">
                  <b-icon icon="download" scale="1.2"></b-icon> Download
                </b-link>
              </div>
              <div v-else class="text-muted small">No impression available</div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-12 text-center">
              <p class="text-info small mb-0">
                <i class="fa fa-info-circle mr-1"></i> Signatures are
                automatically fetched from reference documents and are not
                modifiable here.
              </p>
            </div>
          </div>

          <div class="text-right mt-4 pt-3 border-top">
            <b-button
              variant="secondary"
              @click="showModal = false"
              class="mr-2 custom-wizard-btn"
              >Cancel</b-button
            >
            <b-button type="submit" variant="primary" :disabled="saving">
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </form>
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
export default {
  props: {},
  data() {
    // Updated by Jarir 2026-03-25 : switched to frontend sort/paginate using global mixin
    var columns = [
      { label: "Date", name: "date", type: "date" },
      { label: "Description", name: "description" },
    ];
    var sortOrders = {};
    columns.forEach(function (col) {
      sortOrders[col.name] = -1;
    });

    return {
      apiPrefix: "/admin-service-book",
      employee_id: null,
      items: [],
      loading: false,
      saving: false,
      showModal: false,
      isEdit: false,
      // Updated by Jarir 2026-04-20 — only mark invalid fields after a submit attempt, not on empty open
      submitAttempted: false,
      editId: null,
      baseUrl: window.location.origin,
      columns: columns,
      sortKey: "date",
      sortOrders: sortOrders,
      length: 5,
      pagination: {
        currentPage: 1,
        total: "",
        nextPage: "",
        prevPage: "",
        from: "",
        to: "",
        pages: 1,
      },
      form: {
        date: "",
        description: { en: "", bn: "" },
      },
      ownerSigPreview: null,
      workerSigPreview: null,
      thumbImpPreview: null,
      owner_signature_raw: null,
      worker_signature_raw: null,
      thumb_impression_raw: null,
      signatories: [],
      selected_signatory_id: null,
    };
  },
  computed: {
    // Updated 2026-07-30 — field validity lives here so the modal and saveDetail
    // enforce exactly the same rules. Previously the template checked rules
    // saveDetail did not (Bangla required / Bangla-script only), so a record that
    // saved fine still painted those fields red — a false alarm on Update.
    dateMissing() {
      return this.submitAttempted && !this.isFilled(this.form.date);
    },
    dateMalformed() {
      return !!this.form.date && !/^\d{4}-\d{2}-\d{2}$/.test(this.form.date);
    },
    // Updated 2026-07-30 — one message per field, in priority order, rendered by a single feedback
    // element. A stack of them all lights up at once: Bootstrap shows every .invalid-feedback that
    // follows an .is-invalid control in the same parent, which is how a filled-in field ended up
    // claiming it was required.
    dateError() {
      if (this.dateMissing) return "Date is required";
      if (this.dateMalformed) return "Date must be in YYYY-MM-DD format";
      return "";
    },
    dateState() {
      return this.dateError ? false : null;
    },
    descriptionEnMissing() {
      return this.submitAttempted && !this.isFilled(this.form.description.en);
    },
    descriptionEnUnreadable() {
      return this.hasNoLetterOrDigit(this.form.description.en);
    },
    descriptionEnError() {
      if (this.descriptionEnMissing) return "Behavioral Description (English) is required";
      if (this.descriptionEnUnreadable) return "Behavioral Description must contain letters or numbers";
      // Updated 2026-07-30 — the vee-validate max-length message, on the field it belongs to
      if (this.veeErrors.has("description_en")) return this.veeErrors.first("description_en");
      return "";
    },
    descriptionEnState() {
      return this.descriptionEnError ? false : null;
    },
    // Bangla is optional — only flagged when it holds nothing but special chars,
    // which is the one Bangla rule that actually blocks the save.
    descriptionBnUnreadable() {
      return this.hasNoLetterOrDigit(this.form.description.bn);
    },
    descriptionBnError() {
      if (this.descriptionBnUnreadable) return "আচরণের বিবরণ must contain letters or numbers";
      if (this.veeErrors.has("description_bn")) return this.veeErrors.first("description_bn");
      return "";
    },
    descriptionBnState() {
      return this.descriptionBnError ? false : null;
    },

    // Updated by Jarir 2026-03-30
    signatoryOptions() {
      var options = [{ value: null, text: "Select Signatory" }];
      this.signatories.forEach(function (s) {
        options.push({
          value: s.id,
          text: s.name + " — " + (s.designation || ""),
        });
      });
      return options;
    },
    // Updated by Jarir 2026-03-25 : frontend sort/paginate
    filteredData() {
      var sortKey = this.sortKey;
      var order = this.sortOrders[sortKey] || 1;
      var list = this.items.slice();
      if (sortKey) {
        var index = this.getIndex(this.columns, "name", sortKey);
        list = list.sort(
          function (a, b) {
            a = String(a[sortKey]).toLowerCase();
            b = String(b[sortKey]).toLowerCase();
            if (
              this.columns[index] &&
              this.columns[index].type &&
              this.columns[index].type == "date"
            ) {
              return (
                (a == b
                  ? 0
                  : new Date(a).getTime() > new Date(b).getTime()
                  ? 1
                  : -1) * order
              );
            }
            return (a == b ? 0 : a > b ? 1 : -1) * order;
          }.bind(this),
        );
      }
      return list;
    },
    paginatedData() {
      return this.paginate(
        this.filteredData,
        this.length,
        this.pagination.currentPage,
      );
    },
  },
  created() {
    this.fetchData();
    this.fetchSignatories();
  },
  mounted() {},
  methods: {
    // Updated by Jarir 2026-04-09 — Recursively scan form for HTML tags / PHP code
    findHtmlOrPhpField(data, prefix) {
      var pattern = /<[a-zA-Z!?\/]/;
      if (data === null || data === undefined) return null;
      if (typeof data === "string") {
        if (data && pattern.test(data)) return prefix || "field";
        return null;
      }
      if (typeof data === "object") {
        for (var key in data) {
          if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
          var field = prefix ? prefix + "." + key : key;
          var hit = this.findHtmlOrPhpField(data[key], field);
          if (hit) return hit;
        }
      }
      return null;
    },
    // Updated 2026-07-30 — required means "has real content"; a whitespace-only value
    // used to count as filled, so it passed saveDetail while the field showed red.
    isFilled(value) {
      return (value || "").trim().length > 0;
    },
    // Updated 2026-07-30 — one letter/digit rule shared by the per-field states and
    // findSpecialCharOnlyField, so the red borders can't drift from what blocks a save.
    hasNoLetterOrDigit(value) {
      var trimmed = (value || "").trim();
      return trimmed.length > 0 && !/[a-zA-Z0-9ঀ-৿]/.test(trimmed);
    },
    // Updated by Jarir 2026-04-20 — Reject fields that contain only special chars (no letters/numbers)
    // Accepts Latin (a-z A-Z), Digits (0-9) and Bengali (\u0980-\u09FF) characters as valid
    findSpecialCharOnlyField(data, prefix) {
      if (data === null || data === undefined) return null;
      if (typeof data === "string") {
        if (this.hasNoLetterOrDigit(data)) return prefix || "field";
        return null;
      }
      if (typeof data === "object") {
        for (var key in data) {
          if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
          var field = prefix ? prefix + "." + key : key;
          var hit = this.findSpecialCharOnlyField(data[key], field);
          if (hit) return hit;
        }
      }
      return null;
    },
    // Updated by Jarir 2026-03-30
    // Updated by Jarir 2026-04-23 — employee_id removed; backend reads from session only
    fetchSignatories() {
      axios
        .post(this.apiPrefix + "/get-signatories", {})
        .then((response) => {
          this.signatories = response.data || [];
        })
        .catch((error) => {
          console.error("Error loading signatories:", error);
        });
    },
    onSignatoryChange(sigId) {
      if (!sigId) {
        this.ownerSigPreview = null;
        return;
      }
      var found = null;
      for (var i = 0; i < this.signatories.length; i++) {
        if (this.signatories[i].id == sigId) {
          found = this.signatories[i];
          break;
        }
      }
      if (found && found.signature) {
        var path = "/images/company/signature/" + found.signature;
        // Store raw path temporarily; update owner_signature_raw to the
        // resolved blob URL once the fetch completes so downloadWithName
        // never redirects the browser to a bare server path.
        this.owner_signature_raw = null;
        this.ownerSigPreview = null;
        this.fetchAsBlob(path).then(
          function (b) {
            this.ownerSigPreview = b;
            this.owner_signature_raw = b; // use blob URL for download
          }.bind(this),
        );
      } else {
        this.ownerSigPreview = null;
        this.owner_signature_raw = null;
      }
    },
    fetchAsBlob(url) {
      if (!url) return Promise.resolve(null);
      return fetch(url, { credentials: "same-origin" })
        .then((r) => r.blob())
        .then((blob) => URL.createObjectURL(blob))
        .catch(() => null); // return null on failure; never fall back to the raw path
    },
    openAddModal() {
      this.resetForm();
      this.showModal = true;
      this.fetchCurrentSignatures();
    },
    fetchCurrentSignatures() {
      axios
        .get(this.apiPrefix + "/worker-identification")
        .then((response) => {
          const doc = response.data;
          // Updated by Jarir 2026-04-26 — backend returns base64 data URIs; pass directly, not baseUrl+path
          if (doc.owner_signature) {
            this.owner_signature_raw = doc.owner_signature;
            this.fetchAsBlob(doc.owner_signature).then((b) => { this.ownerSigPreview = b; });
          } else {
            this.ownerSigPreview = null;
            this.owner_signature_raw = null;
          }
          if (doc.signature) {
            this.worker_signature_raw = doc.signature;
            this.fetchAsBlob(doc.signature).then((b) => { this.workerSigPreview = b; });
          } else {
            this.workerSigPreview = null;
            this.worker_signature_raw = null;
          }
          if (doc.worker_thumb_impression) {
            this.thumb_impression_raw = doc.worker_thumb_impression;
            this.fetchAsBlob(doc.worker_thumb_impression).then((b) => { this.thumbImpPreview = b; });
          } else {
            this.thumbImpPreview = null;
            this.thumb_impression_raw = null;
          }
        });
    },
    fetchData() {
      this.loading = true;
      axios
        .get(this.apiPrefix + "/behavioral-records")
        .then((response) => {
          this.items = response.data;
          this.loading = false;
          // Updated by Jarir 2026-04-26 — backend returns base64 data URIs; pass directly
          this.items.forEach((item) => {
            if (item.owner_signature) {
              this.fetchAsBlob(item.owner_signature).then((b) => { this.$set(item, "_ownerBlob", b); });
            }
            if (item.worker_signature) {
              this.fetchAsBlob(item.worker_signature).then((b) => { this.$set(item, "_workerBlob", b); });
            }
            if (item.worker_thumb_impression) {
              this.fetchAsBlob(item.worker_thumb_impression).then((b) => { this.$set(item, "_thumbBlob", b); });
            }
          });
        })
        .catch((error) => {
          this.$bvToast.toast("Error loading records", {
            title: "Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
          this.loading = false;
        });
    },
    // Updated 2026-07-30 — vee-validate gate. The max-length rules run before anything else: an
    // over-limit description keeps its message and the save is blocked, so nothing is silently
    // truncated or saved too long. Descriptions loaded over the limit are caught here too.
    saveDetail() {
      this.submitAttempted = true;
      this.$validator.validateAll().then((valid) => {
        if (!valid) {
          this.$bvToast.toast('Please fix the highlighted fields [marked red]', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
          return;
        }
        this.saveValidatedDetail();
      });
    },
    // Updated by Jarir 2026-03-30 : Added required field validation
    saveValidatedDetail() {
      // Updated by Jarir 2026-04-20 — flip submitAttempted so empty required fields now turn red
      this.submitAttempted = true;
      // Updated 2026-07-30 — read the very messages the fields are painted with, so a red field
      // always means a blocked save and a blocked save always shows red on the field that caused it
      var errors = [];
      [this.dateError, this.descriptionEnError, this.descriptionBnError].forEach(function (message) {
        if (message) errors.push(message);
      });

      // Updated by Jarir 2026-04-26 — Prevent submission if errors exist. Show toast as per accepted style.
      if (errors.length > 0) {
        this.$bvToast.toast('Please fill all required fields [marked red]', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      // Updated by Jarir 2026-04-26 — Block HTML tags / PHP code in any text field
      // Updated 2026-07-30 — these two checks aborted silently, so Update looked dead; report them
      var badField = this.findHtmlOrPhpField(this.form);
      if (badField) {
        this.$bvToast.toast("HTML tags or code are not allowed", {
          title: "Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      // Updated by Jarir 2026-04-20 — Reject fields containing only special characters
      var specialOnly = this.findSpecialCharOnlyField(this.form);
      if (specialOnly) {
        this.$bvToast.toast("Fields must contain letters or numbers [marked red]", {
          title: "Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      this.saving = true;

      // Updated by Jarir 2026-04-23 — employee_id removed; backend reads from session only
      let payload = {
        date: this.form.date,
        description: JSON.stringify(this.form.description),
        signatory_id: this.selected_signatory_id,
      };

      const url = this.isEdit
        ? `${this.apiPrefix}/behavioral-records/${this.editId}`
        : `${this.apiPrefix}/behavioral-records`;

      axios
        .post(url, payload)
        .then((response) => {
          this.$bvToast.toast(
            this.isEdit ? "Updated successfully" : "Saved successfully",
            {
              title: "Success",
              variant: "success",
              solid: true,
              autoHideDelay: 3000,
            },
          );
          this.showModal = false;
          this.fetchData();
          this.saving = false;
        })
        .catch((error) => {
          this.$bvToast.toast("Error saving data", {
            title: "Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
          this.saving = false;
        });
    },
    editItem(item) {
      this.isEdit = true;
      this.editId = item.id;
      // Updated 2026-07-30 — clear stale red borders from a previous submit attempt
      this.submitAttempted = false;

      // Updated 2026-07-30 — always return a fresh object. The API sends description
      // as an object (model casts it to array), so returning it as-is made
      // form.description the very same object as the row's — typing in the modal
      // rewrote the list behind it, and Cancel could not undo it.
      const parseField = (field) => {
        var value = field;
        if (typeof value === "string") {
          try {
            value = JSON.parse(value);
          } catch (e) {
            return { en: field, bn: "" };
          }
        }
        if (!value || typeof value !== "object") return { en: "", bn: "" };
        return { en: value.en || "", bn: value.bn || "" };
      };

      this.form = {
        // Updated by Jarir 2026-04-21 : format date to YYYY-MM-DD (removes T18:00:00... suffix)
        // Updated 2026-07-30 — use formatDate, the same helper the list column uses.
        // item.date arrives as a UTC instant (Carbon::toJSON), so splitting on "T"
        // took the UTC day — one day behind the day the row displays — and silently
        // saved that shifted date on Update.
        date: this.formatDate(item.date) || null,
        description: parseField(item.description),
      };

      // Updated by Jarir 2026-03-30 — set selected signatory from record
      this.selected_signatory_id = item.signatory_id || null;

      // Updated by Jarir 2026-04-26 — backend returns base64 data URIs; pass directly
      if (item.owner_signature) {
        this.owner_signature_raw = item.owner_signature;
        this.fetchAsBlob(item.owner_signature).then((b) => { this.ownerSigPreview = b; });
      } else {
        this.ownerSigPreview = null;
        this.owner_signature_raw = null;
      }
      if (item.worker_signature) {
        this.worker_signature_raw = item.worker_signature;
        this.fetchAsBlob(item.worker_signature).then((b) => { this.workerSigPreview = b; });
      } else {
        this.workerSigPreview = null;
        this.worker_signature_raw = null;
      }
      if (item.worker_thumb_impression) {
        this.thumb_impression_raw = item.worker_thumb_impression;
        this.fetchAsBlob(item.worker_thumb_impression).then((b) => { this.thumbImpPreview = b; });
      } else {
        this.thumbImpPreview = null;
        this.thumb_impression_raw = null;
      }

      this.showModal = true;
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to delete this record? This cannot be undone.",
          {
            title: "Confirm Delete",
            okVariant: "danger",
            okTitle: "Delete",
            cancelTitle: "Cancel",
          },
        )
        .then((confirmed) => {
          if (confirmed) {
            axios
              .delete(
                `${this.$api_url}${this.apiPrefix}/behavioral-records/${id}`,
                {
                  // Updated by Jarir 2026-04-23 — employee_id removed; backend reads from session only
                },
              )
              .then(() => {
                this.$bvToast.toast("Deleted successfully", {
                  title: "Success",
                  variant: "success",
                  solid: true,
                  autoHideDelay: 3000,
                });
                this.fetchData();
              });
          }
        });
    },
    resetForm() {
      this.isEdit = false;
      this.editId = null;
      // Updated by Jarir 2026-04-20 — clear submit flag so red borders don't persist on next open
      this.submitAttempted = false;
      this.form = {
        date: "",
        description: { en: "", bn: "" },
      };
      this.ownerSigPreview = null;
      this.workerSigPreview = null;
      this.thumbImpPreview = null;
      this.owner_signature_raw = null;
      this.worker_signature_raw = null;
      this.thumb_impression_raw = null;
      this.selected_signatory_id = null;
    },
    // Updated by Jarir 2026-04-26 — backend streams PDF directly; use blob responseType
    downloadPdf(lang = "both") {
      this.loading = true;
      axios
        .post(
          this.$api_url + this.apiPrefix + "/download-behavioral-records-pdf",
          { lang: lang },
          { responseType: "blob" },
        )
        .then((response) => {
          this.global_download_file_content(response);
        })
        .catch((error) => {
          console.error("Error downloading PDF:", error);
          this.$bvToast.toast("Error downloading PDF", {
            title: "Error", variant: "danger", solid: true, autoHideDelay: 5000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    emailPdf() {
      this.$bvToast.toast("Email functionality is under preparation.", {
        title: "Email PDF",
        variant: "info",
        solid: true,
        autoHideDelay: 3000,
      });
    },
    getJsonValue(field, lang) {
      if (!field) return "";
      if (typeof field === "object" && field !== null) {
        return field[lang] || "";
      }
      if (typeof field === "string") {
        try {
          const parsed = JSON.parse(field);
          return parsed[lang] || "";
        } catch (e) {
          return field;
        }
      }
      return "";
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "";
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    downloadWithName(path, name) {
      if (!path) return;
      if (path.startsWith('data:image/')) {
        try {
          const parts = path.split(';base64,');
          const contentType = parts[0].split(':')[1];
          const raw = window.atob(parts[1]);
          const rawLength = raw.length;
          const uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) uInt8Array[i] = raw.charCodeAt(i);
          const blob = new Blob([uInt8Array], { type: contentType });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = name + '.' + contentType.split('/')[1];
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
          return;
        } catch (e) {
          console.error("Base64 download failed, falling back to direct URL", e);
        }
      }
      const url = path.startsWith("http") || path.startsWith("data:") || path.startsWith("blob:") ? path : "/" + path;
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.bn-text {
  font-family: "notosansbengali", sans-serif;
}
.bg-light-blue {
  background-color: rgb(234, 246, 255) !important;
}
.bg-light-cyan {
  background-color: #e3f2fd;
}
.custom-table th {
  font-size: 0.85rem;
  vertical-align: middle;
}
.custom-table td {
  vertical-align: middle;
  font-size: 0.9rem;
}
.sig-thumb {
  max-height: 40px;
  max-width: 100px;
}
.img-preview {
  max-height: 80px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Sorting styles */
.sorting {
  position: relative;
  padding-right: 30px !important;
}
.sorting:after,
.sorting:before {
  position: absolute;
  bottom: 0.9em;
  display: block;
  opacity: 0.3;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
.sorting:before {
  right: 1em;
  content: "\f0de"; /* fa-sort-up */
}
.sorting:after {
  right: 1em;
  content: "\f0dd"; /* fa-sort-down */
  top: 1.1em;
}
.sorting_asc:before {
  opacity: 1;
}
.sorting_desc:after {
  opacity: 1;
}

.add-entry-btn {
  /* border-radius: 20px; */
  font-weight: 500;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
</style>
